// 配置管理
import { productionConfig } from './production';
import { testConfig } from './test';
import { logConfigValidation } from './validator';

export interface AppConfig {
  api: {
    baseURL: string;
    version: string;
    path: string;
    timeout: number;
  };
  env: string;
}

// 默认配置
const defaultConfig: AppConfig = {
  api: {
    baseURL: 'http://localhost:8080',
    version: 'v1',
    path: '/api',
    timeout: 10000,
  },
  env: 'development',
};

// 环境配置映射
const envConfigs: Record<string, AppConfig> = {
  development: defaultConfig,
  production: productionConfig,
  test: testConfig,
};

// 从环境变量获取配置
const getConfig = (): AppConfig => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  
  // 如果环境变量中有配置，优先使用环境变量
  if (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_VERSION || process.env.REACT_APP_API_PATH || process.env.REACT_APP_API_TIMEOUT) {
    return {
      api: {
        baseURL: process.env.REACT_APP_API_BASE_URL || defaultConfig.api.baseURL,
        version: process.env.REACT_APP_API_VERSION || defaultConfig.api.version,
        path: process.env.REACT_APP_API_PATH || defaultConfig.api.path,
        timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10),
      },
      env,
    };
  }
  
  // 否则使用预定义的环境配置
  return envConfigs[env] || defaultConfig;
};

// 导出配置实例
export const config = getConfig();

// 在开发环境下验证配置
if (process.env.NODE_ENV === 'development') {
  logConfigValidation(config);
}

// 导出配置构建函数 - 支持相对路径和绝对路径
export const buildApiUrl = (endpoint: string = ''): string => {
  const baseURL = config.api.baseURL;
  const path = config.api.path;
  const version = config.api.version;
  
  // 如果baseURL是相对路径（以/开头），则直接使用
  if (baseURL.startsWith('/')) {
    return `${baseURL}${path}/${version}${endpoint}`;
  }
  
  // 否则使用完整的URL
  return `${baseURL}${path}/${version}${endpoint}`;
};

export const buildAdminApiUrl = (endpoint: string = ''): string => {
  const baseURL = config.api.baseURL;
  const path = config.api.path;
  const version = config.api.version;
  
  // 如果baseURL是相对路径（以/开头），则直接使用
  if (baseURL.startsWith('/')) {
    return `${baseURL}${path}/${version}/admin${endpoint}`;
  }
  
  // 否则使用完整的URL
  return `${baseURL}${path}/${version}/admin${endpoint}`;
};

// 导出环境配置
export { productionConfig, testConfig };

// 重新导出其他配置模块
export * from './ui';
export * from './constants';
export * from './validator'; 